// Recharge Storefront Experiences cart drawer (mini-cart)
// Kept separate from product script for performance.

// Styles for Recharge Storefront Experiences cart drawer shadow root
const rechargeCartStyles = `
.text-storefront-drawer-accent {
    color: #535a5d !important;
}

.text-storefront-drawer-accent {
    font-weight: 400 !important;
}
`;

// Cross-sell is the only carousel inside this shadow root.
// Stack its slides vertically and keep Recharge's own data-cart-custom style untouched.
const rechargeCrossSellStyles = `
[data-slot="carousel"] {
    margin-left: 0 !important;
    margin-right: 0 !important;
    height: auto !important;
}

[data-slot="carousel"] [data-slot="carousel-content"] {
    overflow: visible !important;
    height: auto !important;
}

[data-slot="carousel"] [data-slot="carousel-content"] > div {
    flex-direction: column !important;
    transform: none !important;
    margin-left: 0 !important;
    height: auto !important;
    gap: 12px;
}

[data-slot="carousel"] [data-slot="carousel-item"] {
    flex: 0 0 auto !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    transform: none !important;
    padding-left: 0 !important;
}

[data-slot="carousel-previous"],
[data-slot="carousel-next"] {
    display: none !important;
}
`;

// --- Mini-cart drawer adjustments (Recharge Storefront Experiences) ---
// Hide dl.flex-col in mini-cart item when title does NOT contain "kind 6-stage"
(function initRechargeMiniCartAdjustments() {
	try {
		// Find the cart drawer host (custom element with shadow root)
		const findHost = () => document.getElementById('recharge-storefront-experiences__cart-drawer');

		// Visual-only price swap inside Recharge cart drawer shadow root.
		// Matches title (case-insensitive substring) + fromPrice, hides original, shows toPrice.
		const replaceCartPrice = (root, titleMatch, fromPrice, toPrice) => {
			if (!root || !titleMatch || !fromPrice || !toPrice) return;
			const fromNorm = String(fromPrice).replace(/\s+/g, '').trim();
			const titleRe = new RegExp(
				String(titleMatch).replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+'),
				'i'
			);

			root.querySelectorAll('span[part="money"]').forEach((el) => {
				if (el.dataset.rcPriceFake) return;
				const priceText = (el.textContent || '').replace(/\s+/g, '').trim();
				if (priceText !== fromNorm) return;

				// Title sits in the same flex-col as the price (div.font-semibold, not p)
				const col = el.parentElement;
				const titleEl = col?.querySelector('.font-semibold')
					|| el.closest('.rounded-storefront-drawer, [role="listitem"]')?.querySelector('.font-semibold');
				const title = (titleEl?.textContent || '').trim();
				if (!titleRe.test(title)) return;

				el.style.setProperty('display', 'none', 'important');

				let fake = el.nextElementSibling;
				if (!fake || !fake.dataset?.rcPriceFake) {
					fake = document.createElement('span');
					fake.dataset.rcPriceFake = 'true';
					fake.className = el.className;
					fake.textContent = toPrice;
					el.after(fake);
				}
			});
		};

		// Apply visibility rules inside shadow root
		const applyRules = (host) => {
			const root = host && host.shadowRoot;
			if (!root) return;

			// Inject custom styles into cart drawer shadow root (once).
			// Leave Recharge's data-cart-custom style alone; cross-sell rules live in their own tag.
			if (!root.querySelector('style[data-cart-custom="true"]')) {
				try {
					const style = document.createElement('style');
					style.dataset.cartCustom = 'true';
					style.textContent = rechargeCartStyles;
					root.appendChild(style);
				} catch (_) {}
			}

			if (!root.querySelector('style[data-cart-cross-sell="true"]')) {
				try {
					const style = document.createElement('style');
					style.dataset.cartCrossSell = 'true';
					style.textContent = rechargeCrossSellStyles;
					root.appendChild(style);
				} catch (_) {}
			}

			// Only when drawer is open (data-state="open" exists deeper)
			const openRoot = root.querySelector('[data-state="open"]') || root;
			if (!openRoot) return;

			// Always hide any strikethrough spans inside the mini-cart
			try {
				openRoot.querySelectorAll('span.line-through:not(footer *)').forEach((el) => {
					el.style.setProperty('display', 'none', 'important');
				});
			} catch (_) {}

			// Toggle HubSpot chat icon based on drawer state
			const isOpen = !!root.querySelector('[data-state="open"]');
			const chatEl = document.getElementById('hubspot-messages-iframe-container');
			if (chatEl) {
				if (isOpen) {
					// Force hide with inline !important to override HubSpot's own !important
					try { chatEl.style.setProperty('display', 'none', 'important'); } catch(_) {}
					// Keep it hidden if HubSpot re-writes styles while the drawer stays open
					if (!chatEl.__rcChatObs) {
						const obs = new MutationObserver(() => {
							try { chatEl.style.setProperty('display', 'none', 'important'); } catch(_) {}
						});
						try {
							obs.observe(chatEl, { attributes: true, attributeFilter: ['style'] });
							chatEl.__rcChatObs = obs;
						} catch(_) {}
					}
				} else {
					// Drawer closed: stop enforcing and show chat again
					try {
						if (chatEl.__rcChatObs) {
							chatEl.__rcChatObs.disconnect();
							chatEl.__rcChatObs = null;
						}
						chatEl.style.setProperty('display', 'initial', 'important');
					} catch(_) {}
				}
			}

			// Visual-only price swaps: title + fromPrice - toPrice
			try {
				replaceCartPrice(root, 'E-Series DIY Installation Kit', '$119.95', '$99.95');
				replaceCartPrice(root, 'E-Series UV DIY Installation Kit', '$149.95', '$129.95');
			} catch (_) {}

			// Iterate line items
			const items = openRoot.querySelectorAll('section[role="list"] [role="listitem"]');
			if (!items || !items.length) return;

			for (const item of items) {
				// Title element (matches structure: .w-full.text-sm ... p.font-semibold)
				const titleP = item.querySelector('div.w-full.text-sm p.font-semibold') || item.querySelector('p.font-semibold');
				const dl = item.querySelector('dl.flex-col');
				if (!dl) continue;

				const title = (titleP?.textContent || '').trim();
				const containsRO = /kind 6-stage/i.test(title);

				// Toggle details visibility
				if (containsRO) {
					if (dl.style.display === 'none') dl.style.display = '';
				} else {
					if (dl.style.display !== 'none') dl.style.display = 'none';
				}
			}
		};

		const bindHostObserver = (host) => {
			if (!host || host.__rcMiniCartObserved) return;
			host.__rcMiniCartObserved = true;

			// Observe shadow DOM for open/close and content changes
			const root = host.shadowRoot;
			if (!root) return;

			// Debounced apply to avoid thrashing
			let scheduled = false;
			const schedule = () => {
				if (scheduled) return;
				scheduled = true;
				setTimeout(() => {
					scheduled = false;
					applyRules(host);
				}, 50);
			};

			// Initial apply (in case it's already open)
			applyRules(host);

			const mo = new MutationObserver(schedule);
			mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-state'] });
		};

		// Fast path: bind immediately if already present
		const immediate = findHost();
		if (immediate && immediate.shadowRoot) {
			bindHostObserver(immediate);
			return;
		}

		// Lazy start: wait for first user interaction, then poll briefly for the host.
		let polling = false;
		const startPolling = () => {
			if (polling) return;
			const existing = findHost();
			if (existing && existing.shadowRoot) {
				bindHostObserver(existing);
				return;
			}
			polling = true;

			let tries = 0;
			const maxTries = 160; // 40s @ 250ms, only after interaction
			const timer = setInterval(() => {
				tries += 1;
				const host = findHost();
				if (host && host.shadowRoot) {
					clearInterval(timer);
					polling = false;
					bindHostObserver(host);
					return;
				}
				if (tries >= maxTries) {
					clearInterval(timer);
					polling = false;
				}
			}, 250);
		};

		document.addEventListener('pointerdown', startPolling, true);
		document.addEventListener('keydown', startPolling, true);
	} catch (_) {}
})();
